export const stats = [
  { id: 1, value: 12, suffix: '+', label: 'Anos de Tradição' },
  { id: 2, value: 15000, suffix: '+', label: 'Clientes Atendidos' },
  { id: 3, value: 4.9, suffix: '', label: 'Avaliação Google', isDecimal: true },
  { id: 4, value: 50000, suffix: '+', label: 'Cortes Realizados' },
];